import core from '@/core';
import { launchTrackStorageKey } from '@/constants/commonConst.ts';
import { handleSetStorage } from './common.ts';
import type { IBaseTrackData, IExtraTrackData, IParamData } from '@/types/DataStore.ts';

let pageEnterTime;
let _dataStore;
export function handleAppLaunch(opts?: IBaseTrackData & IExtraTrackData) {
  console.log('web app load opts: ', opts);
  _dataStore = core.getDataStoreInstance();
  handleSetStorage(launchTrackStorageKey, opts);
  core.track('launch', opts || {});
}
export function handlePageEnter(opts?: IParamData) {
  pageEnterTime = new Date().getTime();
  core.track('enter', opts || undefined);
}

export function handlePageLeave({
  opts,
  extraReport,
}: { opts?: IParamData; extraReport?: IBaseTrackData | IExtraTrackData } = {}) {
  const pageLeaveTime = new Date().getTime();
  const timeDiff = pageLeaveTime - pageEnterTime;
  _dataStore.setExtraDataObj({});
  core.track('leave', opts || undefined, {
    extraReportBase: {
      residenceTime: timeDiff,
      ...extraReport,
    },
  });
}
const webHandle = {
  handleAppLaunch,
  handlePageEnter,
  handlePageLeave,
};
export default webHandle;
